import React, { useEffect } from 'react';
import './styles/ResumeSectionDesktop.css';
import './styles/ResumeSectionMobile.css';
import { animateResumeEntries, attachResumeMouseTracking } from './AnimateResumeEntries.js';

function UnitedKingdomResume() {
    useEffect(() => {
        const resumeEntries = document.querySelectorAll("div.resumeentry");
        animateResumeEntries(resumeEntries);

        const onScroll = () => animateResumeEntries(resumeEntries);
        document.addEventListener('scroll', onScroll);
        const detachMouse = attachResumeMouseTracking(resumeEntries);

        return () => {
            document.removeEventListener('scroll', onScroll);
            detachMouse();
        };
    }, []);


  return (
    <div>
    <div className="resumeentry animateddiv">
        <div className="resumeentryimagecontainer">
            <img className="resumeentryimage" src={require('./assets/universityofsurreyoriginal.png')} alt="University of Surrey"/>
        </div>

        <div className="resumetextcontainer">
            <div className="resumetextheader">
                <div className="resumeentrytitle">
                    <h1>BSc Computer Science <span className="title-divider">|</span> Valedictorian, Class of 2017</h1>
                </div>
                <div className="resumeentryimagetypecontainer"><img className="resumeentryimagetypeemoji" src={require('./assets/education.png')} alt="Education"/></div>
            </div>

            <div className="resumeentrydate">
                <p>September 2014 — September 2017</p>
            </div>
            <div className="resumeentrytext">
                <p>
                    Where it all began. My final year thesis focused on the intersection of Neural and Bayesian networks applied to the domain of Road Safety.
                    Combining these models into a production application, I built the infrastructure to plot the safest routes between destinations.
                </p>
                <div className="resumeprojectwinner">
                    <div className="resumeemoji">🥇 Winner — 4 Academic Awards 🥇</div>
                </div>
                <ul>
                    <li>Department of Computing Prize for Best Overall Performance</li>
                    <li>IBM Prize for Best Final Year Performance</li>
                    <li>Department for Energy and Climate Change Prize</li>
                    <li>Best Final Year Project </li>
                </ul>
            </div>
        </div>
    </div>

    <div className="resumeentry animateddiv">
        <div className="resumeentryimagecontainer">
            <img className="resumeentryimage" src={require('./assets/ContextualShuffle.png')} alt="ContextualShuffle"/>
        </div>

        <div className="resumetextcontainer">
            <div className="resumetextheader">
                <div className="resumeentrytitle">
                    <h1>ContextualShuffle <span className="title-divider">|</span> Tech Lead <span className="title-divider">|</span> <a href="https://www.devpost.com/software/contextualshuffle" target="_blank" rel="noopener noreferrer">Devpost</a></h1>
                </div>
                <div className="resumeentryimagetypecontainer"><img className="resumeentryimagetypeemoji" src={require('./assets/project.png')} alt="Project"/></div>
            </div>

            <div className="resumeprojectwinner">
                <div className="resumeemoji">🥇 Winner — ICHACK 2017 (largest student hack in the UK) 🥇</div>
            </div>
            <div className="resumeentrytext">
                    <p> Generates a "shuffle" of songs based on the current context of songs the user is listening to and utilises decision trees
                        to queue similar songs in the playlist to reduce the variation between tracks, e.g. hiphop would not follow classical.
                    </p>
            </div>
        </div>
    </div>

    <div className="resumeentry animateddiv">
        <div className="resumeentryimagecontainer">
            <img className="resumeentryimage" src={require('./assets/research.png')} alt="Research"/>
        </div>

        <div className="resumetextcontainer">
            <div className="resumetextheader">
                <div className="resumeentrytitle">
                    <h1>On Making Sense of Neural Networks in Road Analysis</h1>
                </div>
                <div className="resumeentryimagetypecontainer"><img className="resumeentryimagetypeemoji" src={require('./assets/researchpaper.png')} alt="Research paper"/></div>
            </div>

            <div className="resumeprojectwinner">
                <div className="resumeemoji"> 🥇 Winner — The Sean Morley Memorial Award (UK Government Grant) 🥇</div>
                <div className="resumeemoji">📖  <a href="https://ieeexplore.ieee.org/document/7966415" target="_blank" rel="noopener noreferrer">IJCNN 2017</a> 📖</div>
            </div>
            <div className="resumeentrytext">
                    <p> Proposed a new Bayesian-neural network hybrid machine learning technique which combines the transparency and ease of
                        computation of Bayesian networks with the advanced learning methodologies of neural networks. This hybrid model can predict
                        road accidents with 85% accuracy.
                    </p>
            </div>
        </div>
    </div>

    </div>
  );
}

export default UnitedKingdomResume;
